import { IconProps } from "@utils/types/components";

export const MenuIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.75 8.75c-1.169 0-2.17-.416-3.002-1.248C.916 6.669.5 5.669.5 4.5c0-1.169.416-2.17 1.248-3.002C2.581.666 3.581.25 4.75.25c1.169 0 2.17.416 3.002 1.248C8.584 2.331 9 3.331 9 4.5c0 1.169-.416 2.17-1.248 3.002-.833.832-1.833 1.248-3.002 1.248zm12.75 0c-1.169 0-2.17-.416-3.002-1.248-.832-.833-1.248-1.833-1.248-3.002 0-1.169.416-2.17 1.248-3.002C15.331.666 16.331.25 17.5.25c1.169 0 2.17.416 3.002 1.248.832.833 1.248 1.833 1.248 3.002 0 1.169-.416 2.17-1.248 3.002-.833.832-1.833 1.248-3.002 1.248zm12.75 0c-1.169 0-2.17-.416-3.002-1.248C26.416 6.669 26 5.669 26 4.5c0-1.169.416-2.17 1.248-3.002C28.081.666 29.081.25 30.25.25c1.169 0 2.17.416 3.002 1.248.832.833 1.248 1.833 1.248 3.002 0 1.169-.416 2.17-1.248 3.002-.833.832-1.833 1.248-3.002 1.248z"
        fill={color}
      />
    </svg>
  );
};
